enum LOCALSTORAGE_ITEMS {
  lang = 'lang',
}

export const getLanguage = () => {
  type langType = 'ko' | 'en' | 'ja' | 'ch' | 'ru'
  const lang = getLocalStorageItem(LOCALSTORAGE_ITEMS.lang)
  return (lang || 'ko') as langType
}

export const setLanguage = (lang: string) => {
  setLocalStorageItem(LOCALSTORAGE_ITEMS.lang, lang)
}


const getLocalStorageItem = (key: string) => {
  const data: any = typeof window !== 'undefined' ? localStorage.getItem(key) : ''

  try {
    return JSON.parse(data)
  } catch (err) {
    return data
  }
}


const setLocalStorageItem = (key: string, value: any) => {
  const stringify = typeof value !== 'string' ? JSON.stringify(value) : value
  return localStorage.setItem(key, stringify)
}

const removeLocalStorageItem = (key: string) => {
  localStorage.removeItem(key)
}


const appendLocalStorageItem = (key: string, value: any) => {
  const data: any = typeof window !== 'undefined' ? localStorage.getItem(key) : ''
  try {
    const parsedList =  JSON.parse(data)
    parsedList
      ? localStorage.setItem(key, JSON.stringify([value, ...parsedList])) 
      : localStorage.setItem(key, JSON.stringify([value]))
  } catch (err) {
    return data
  }

}



export { getLocalStorageItem, setLocalStorageItem, removeLocalStorageItem, appendLocalStorageItem, LOCALSTORAGE_ITEMS};
